import { render, staticRenderFns } from "./kpi-cards.vue?vue&type=template&id=f871015c"
import script from "./kpi-cards.vue?vue&type=script&lang=js"
export * from "./kpi-cards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports